import mapStyles from './map-styles.json'
import mapIconDisplay from '../../images/map-pin-new.png';

export default {
  initMap() {
    window.locMap = null;
    window.locations = null;
    let self = this;
    window.locMap = new window.google.maps.Map(document.querySelector('.map'), {
      zoom: 5.8,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      center: new window.google.maps.LatLng(-31.8345231, 133.5293524),
      mapTypeId: window.google.maps.MapTypeId.ROADMAP,
      styles: mapStyles,
    });

    if (window.locMap !== null) {
      self.getLocations();
      self.selectLocation();
    }

    // $(window).on('load', function () {
    //   setTimeout(() => {
    //     window.locMap = new window.google.maps.Map(document.querySelector('.map'), {
    //       zoom: 12,
    //       streetViewControl: false,
    //       mapTypeControl: false,
    //       fullscreenControl: false,
    //       center: new window.google.maps.LatLng(-38.027232773469194, 145.1926131092577),
    //       mapTypeId: window.google.maps.MapTypeId.ROADMAP,
    //       styles: mapStyles,
    //     });
    //   }, 1000);

    //   if (window.locMap !== null) {
    //     self.getLocations();
    //     self.selectLocation();
    //   }
    // });
  },
  getLocations() {
    let self = this;

    $.ajax({
      url: window.PConfig.ajaxUrl,
      type: 'POST',
      data: {
        action: 'map',
      },
      success: function (response) {
        window.locations = response;
        self.addMarkers(window.locations);
      },
      error: function (xhr, status, error) {
        // Handle errors
        console.error(xhr.responseText);
        console.log(error);
        console.log(status);
      },
    });

  },
  addMarkers(locations) {
    if (locations.length > 0) {
      let markers = [];

      let markerImage = {
        url: mapIconDisplay,
        size: new window.google.maps.Size(48, 48),
        origin: new window.google.maps.Point(0, 0),
        scaledSize: new window.google.maps.Size(48, 48),
      };

      locations.forEach(function (item) {
        if (item.map !== null) {
          let marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(item.map.lat, item.map.lng),
            title: item.title,
            icon: markerImage,
          });

          markers.push(marker);
        }
      });

      new window.MarkerClusterer(window.locMap, markers, {
        maxZoom: 12,
        gridSize: 50,
        styles: [{
          width: 80,
          height: 80,
          url: mapIconDisplay,
          textColor: '#ffffff',
          textSize: 20,
        }],
      });

    }
  },
  selectLocation(){
    $('.location').on('click', function(){
      let locations = window.locations;
      let id = $(this).data('location');
      // $('.location').removeClass('clicked')
      // $('.location[data-location="' + $(this).data('location') + '"]').addClass('clicked')

      if (locations.length > 0) {
        locations.forEach(function (item) {
          if(item.id == id && item.map !== null){
            let position = new window.google.maps.LatLng(item.map.lat, item.map.lng);
            window.locMap.setCenter(position);
          }
        });
      }

      return false;
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/layouts/map.js